import { render, staticRenderFns } from "./SpamList.vue?vue&type=template&id=7ae9dc62&scoped=true"
import script from "./SpamList.vue?vue&type=script&lang=ts"
export * from "./SpamList.vue?vue&type=script&lang=ts"
import style0 from "./SpamList.vue?vue&type=style&index=0&id=7ae9dc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae9dc62",
  null
  
)

export default component.exports